import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import { formateDate, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import * as teamManagers from "../../../services/teamManagers.service";

const TeamManagerView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Team Managers", url: "/admin/user-management/team-managers/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    teamManagers
      .Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">Team Manager View</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>{t("Profile Picture")}</th>
                          <td>
                            {showdefault?.profile_image && showdefault.profile_image !== "N/A" ? (
                              <img 
                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '50%' }}
                                src={showdefault.profile_image} 
                                alt="Profile" 
                              />
                            ) : (
                              <div style={{ width: '50px', height: '50px', background: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', fontSize: '10px', color: '#9ca3af' }}>
                                No Image
                              </div>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault.firstName || "N/A"} {showdefault.lastName || ""}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>{showdefault.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Club Email")}</th>
                          <td>{showdefault.clubEmail || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_city")}</th>
                          <td>{showdefault.city || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_country")}</th>
                          <td>{showdefault.country || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td>
                            {showdefault?.status ? (
                              <span
                                className={`badge badge-pill fw-bold text-uppercase px-3 py-2 ${
                                  showdefault.status.toLowerCase() === "active"
                                    ? "badge-success-light"
                                    : "badge-danger-light"
                                }`}
                              >
                                {showdefault.status}
                              </span>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_verification")}</th>
                          <td>
                            {showdefault?.isProfileVerified ? (
                              <span
                                className={`badge badge-pill fw-bold text-uppercase px-3 py-2 ${
                                  showdefault.isProfileVerified === "verified"
                                    ? "badge-success-light"
                                    : showdefault.isProfileVerified === "rejected"
                                    ? "badge-danger-light"
                                    : "badge-warning-light"
                                }`}
                              >
                                {showdefault.isProfileVerified}
                              </span>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-4 d-flex gap-2">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                      <button
                        className="btn ripple btn-success text-white"
                        type="button"
                        onClick={() => navigate(`/admin/user-management/audit-logs/${params.id}`)}
                      >
                        <i className="ri-history-fill mx-1"></i>
                        View Audit Logs
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph
                  className="w-100 admin-placeholder"
                  rowHeight={30}
                  rowSpacing={5}
                  active={true}
                  rows={7}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamManagerView;
